import React, { FC } from 'react';
import { css } from 'glamor';
import { ModalPatternProps } from './types/ModalPattern';

const ModalPattern: FC<ModalPatternProps> = ({
  padding = 22,
  backgroundSize = 'cover',
  display = 'inherit',
  customStyle = {},
  children,
}: ModalPatternProps) => {
  const bgImageStyle: React.CSSProperties = {
    backgroundSize,
    padding,
    display,
  };

  return (
    <div className={`${css(bgImageStyle)}`} style={customStyle}>
      {children}
    </div>
  );
};

export default ModalPattern;
